module.exports = __webpack_public_path__ + "media/honey-icons/icon-spinner-539c6eca.svg";